export enum QuoteStatus {
    Draft = 0,
    Pending,
    Paid,
    Approved,
    Rejected,
    Void,
}
